import { render, staticRenderFns } from "./SeccionPostitulos.vue?vue&type=template&id=0e35939c&scoped=true"
import script from "./SeccionPostitulos.vue?vue&type=script&lang=js"
export * from "./SeccionPostitulos.vue?vue&type=script&lang=js"
import style0 from "./SeccionPostitulos.vue?vue&type=style&index=0&id=0e35939c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e35939c",
  null
  
)

export default component.exports